import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Subject } from 'rxjs';
import { MatIcon } from '@angular/material/icon';

export class BreadcrumbItem {
  label?: string;
  type?: 'record' | 'view' | 'form' | 'unknown';
  popCount?: number;
}

@Component({
    selector: 'app-breadcrumb-item',
    templateUrl: './breadcrumb-item.component.html',
    styleUrls: ['./breadcrumb-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon]
})
export class BreadcrumbItemComponent {
  readonly level = input<number>(0);
  readonly item = input<BreadcrumbItem>(undefined);
  readonly onClick = output<BreadcrumbItem>();

  hovered: boolean = false;
  filteredOptions: Subject<{ label: string; value: string }[]> = new Subject<{ label: string; value: string }[]>();

  getClasses(): { [key: string]: boolean } {
    const classes = {};
    classes[`level-${this.level()}`] = true;
    classes['hovered'] = this.hovered;
    return classes;
  }
}
